import { requestLogService } from '@/services/api/requestLog.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { requestLogModel } from '@/models/api/requestLog.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const REQUEST_LOG_MODULE = "api/requestLog";

// ACTIONS
export const GET_ALL_REQUEST_LOG = 'getAllRequestLog';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_REQUEST_LOG_SUCCESS = "allRequestLogSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_REQUEST_LOG]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        requestLogService
            .getAll(filter)
            .then((result) => {
                commit(ALL_REQUEST_LOG_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_REQUEST_LOG_SUCCESS](state, {data}) {
        let requestLogList = data.data || [];
        state.list.data = requestLogList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = requestLogList.map(item => requestLogModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};
